import qs from 'qs';
import {MimeType} from '../../../express/constants';
import {axiosBffFetch, FetcherOptions} from '../../axios/axiosBffFetch';
import type {ApiResultVo} from '../../common/shared/api/nicolas/vo/ApiResultVo.interface';
import {GetSingleResultVo} from '../../common/shared/api/nicolas/vo/GetSingleResultVo.interface';

/**
 * 회차(Single) 정보
 *
 * Origin: pageNicolasApi.getSingle
 * API: POST /api/v6/store/get/single
 */
export async function postStoreGetSingle(
  {
    productId,
  }: {
    productId: number;
  },
  options?: FetcherOptions
): Promise<ApiResultVo & GetSingleResultVo> {
  const response = await axiosBffFetch(
    '/api/gateway/api/v6/store/get/single',
    {
      method: 'POST',
      data: qs.stringify({singleid: productId, preview: true}),
      headers: {
        'Content-Type': MimeType.FormUrlEncoded,
      },
    },
    options
  );
  return response.data;
}
